export default "__VITE_ASSET__BG28T64C__"